import { render, staticRenderFns } from "./BreachContract.vue?vue&type=template&id=1df89cea&scoped=true&"
import script from "./BreachContract.vue?vue&type=script&lang=js&"
export * from "./BreachContract.vue?vue&type=script&lang=js&"
import style0 from "./BreachContract.vue?vue&type=style&index=0&id=1df89cea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df89cea",
  null
  
)

export default component.exports